/* ===================================================
   ME knit -- App JavaScript (Shopify Theme)
   Scroll reveal, menu toggle, carousel, price slider,
   product gallery + variant picker
   =================================================== */

(function () {
  'use strict';

  // -- Scroll Reveal --
  function initScrollReveal() {
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    reveals.forEach(function (el) { observer.observe(el); });
  }

  // -- Header Shadow on Scroll --
  function initHeaderShadow() {
    var header = document.getElementById('header');
    if (!header) return;

    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // -- Hamburger Menu --
  function initMenu() {
    var btn = document.getElementById('hamburger-btn');
    var overlay = document.getElementById('menu-overlay');
    var closeBtn = document.getElementById('menu-close');
    if (!btn || !overlay) return;

    function openMenu() {
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      btn.classList.add('active');
    }

    function closeMenu() {
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      btn.classList.remove('active');
    }

    btn.addEventListener('click', function () {
      if (overlay.classList.contains('open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeMenu();
    });

    // Swipe right anywhere on the page to open it (the button is at the top, out of thumb reach).
    // Not from the screen edges (Android's back gesture) and not on rows that scroll sideways.
    var pageX = null;
    var pageY = null;
    document.addEventListener('touchstart', function (e) {
      pageX = null;
      if (overlay.classList.contains('open') || e.touches.length !== 1) return;
      var x = e.touches[0].clientX;
      if (x < 24 || x > window.innerWidth - 24) return;
      for (var el = e.target; el && el !== document.body; el = el.parentElement) {
        if (el.scrollWidth > el.clientWidth + 1 && /auto|scroll/.test(getComputedStyle(el).overflowX)) return;
        if (el.id === 'parcelyWidget' || el.tagName === 'DIALOG') return;
      }
      pageX = x;
      pageY = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (pageX === null) return;
      var dx = e.changedTouches[0].clientX - pageX;
      var dy = e.changedTouches[0].clientY - pageY;
      pageX = null;
      if (dx > 70 && Math.abs(dx) > Math.abs(dy) * 1.5) openMenu();
    }, { passive: true });

    // Swipe left on the menu to close it (the close button is at the top, out of thumb reach)
    var touchX = null;
    var touchY = null;
    overlay.addEventListener('touchstart', function (e) {
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
    }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      var dy = e.changedTouches[0].clientY - touchY;
      touchX = null;
      if (dx < -70 && Math.abs(dx) > Math.abs(dy) * 1.5) closeMenu();
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('open')) {
        closeMenu();
      }
    });
  }

  // -- Footer link groups: closed on phones, always open on computers --
  function initFooterGroups() {
    var groups = document.querySelectorAll('.footer__group');
    if (!groups.length) return;
    var phone = window.matchMedia('(max-width: 768px)');

    function apply() {
      groups.forEach(function (group) {
        if (phone.matches) {
          group.removeAttribute('open');
        } else {
          group.setAttribute('open', '');
        }
      });
    }

    apply();
    if (phone.addEventListener) phone.addEventListener('change', apply);
  }

  // -- Featured Products Carousel --
  function initCarousel() {
    var grid = document.getElementById('featured-grid');
    var prevBtn = document.getElementById('carousel-prev');
    var nextBtn = document.getElementById('carousel-next');
    if (!grid || !prevBtn || !nextBtn) return;

    function getScrollAmount() {
      var card = grid.querySelector('.product-card');
      if (!card) return 200;
      var style = window.getComputedStyle(grid);
      var gap = parseFloat(style.columnGap) || 16;
      return (card.offsetWidth + gap) * 2;
    }

    function updateButtons() {
      prevBtn.disabled = grid.scrollLeft <= 5;
      nextBtn.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 5;
    }

    prevBtn.addEventListener('click', function () {
      grid.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      grid.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    grid.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    setTimeout(updateButtons, 100);
  }

  // -- Product Gallery (one large photo on desktop, swipeable on mobile) --
  // Photos keep the order set in Shopify. When the customer picks another photo
  // (thumbnail, swipe or the full-screen viewer), onPhotoPicked lets the colour follow.
  var productGallery = null;

  function initProductGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    var thumbBar = document.querySelector('[data-product-thumbs]');
    if (!gallery) return;

    var items = gallery.querySelectorAll('[data-media-id]');
    var activeItem = gallery.querySelector('.product-gallery__item.is-active') || items[0];
    var swiping = false;   // the customer, not the page, is moving the photo strip
    var settleTimer = null;

    function getItem(mediaId) {
      return gallery.querySelector('[data-media-id="' + mediaId + '"]');
    }

    function isMobile() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    function setActiveThumb(mediaId) {
      if (!thumbBar) return;
      thumbBar.querySelectorAll('.product-layout__thumb').forEach(function (t) {
        var isActive = t.getAttribute('data-thumb-for') === String(mediaId);
        t.classList.toggle('active', isActive);
        // Keep the active thumbnail visible inside the scrolling thumb strip
        if (isActive && !isMobile()) {
          var top = t.offsetTop;
          var bottom = top + t.offsetHeight;
          if (top < thumbBar.scrollTop || bottom > thumbBar.scrollTop + thumbBar.clientHeight) {
            thumbBar.scrollTo({ top: top, behavior: 'smooth' });
          }
        }
      });
    }

    function markActive(item) {
      activeItem = item;
      items.forEach(function (el) {
        el.classList.toggle('is-active', el === item);
      });
      setActiveThumb(item.getAttribute('data-media-id'));
    }

    function photoPicked(item) {
      if (item === activeItem) return;
      markActive(item);
      if (productGallery.onPhotoPicked) productGallery.onPhotoPicked(item.getAttribute('data-media-id'));
    }

    // Desktop: swap the large photo. Mobile: slide the carousel to it.
    // picked: the customer chose this photo, rather than a colour that has it.
    function showMedia(mediaId, picked) {
      var item = getItem(mediaId);
      if (!item) return;
      if (isMobile()) {
        swiping = false;
        gallery.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      }
      if (picked) photoPicked(item);
      else markActive(item);
    }

    if (thumbBar) {
      thumbBar.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb-for]');
        if (thumb) showMedia(thumb.getAttribute('data-thumb-for'), true);
      });
    }

    // Mobile: the photo a swipe comes to rest on counts as picked
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (type) {
      gallery.addEventListener(type, function () { swiping = true; }, { passive: true });
    });
    gallery.addEventListener('scroll', function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        if (!isMobile() || !items.length) return;
        var inView = activeItem;
        var nearest = Infinity;
        items.forEach(function (el) {
          var distance = Math.abs(el.offsetLeft - gallery.scrollLeft);
          if (distance < nearest) { nearest = distance; inView = el; }
        });
        if (swiping) {
          swiping = false;
          photoPicked(inView);
        } else {
          markActive(inView);
        }
      }, 150);
    }, { passive: true });

    // Start at the photo shown first (a linked colour's photo can be further along):
    // phones slide the photo strip to it, computers scroll its thumbnail into view
    if (activeItem && activeItem !== items[0]) {
      if (isMobile()) gallery.scrollLeft = activeItem.offsetLeft;
      else setActiveThumb(activeItem.getAttribute('data-media-id'));
    }

    // Mobile: highlight the thumbnail of the photo swiped into view
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!isMobile()) return;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActiveThumb(entry.target.getAttribute('data-media-id'));
        });
      }, { root: gallery, threshold: 0.5 });
      gallery.querySelectorAll('[data-media-id]').forEach(function (item) { observer.observe(item); });
    }

    productGallery = { showMedia: showMedia, onPhotoPicked: null };
  }

  // -- Photo Viewer: full-screen product photos with pinch, double-tap, click and wheel zoom --
  function initPhotoViewer() {
    var gallery = document.querySelector('[data-product-gallery]');
    var dialog = document.querySelector('[data-photo-viewer]');
    if (!gallery || !dialog || typeof dialog.showModal !== 'function') return;

    var stage = dialog.querySelector('[data-photo-stage]');
    var img = dialog.querySelector('[data-photo-image]');
    var countEl = dialog.querySelector('[data-photo-count]');
    var prevBtn = dialog.querySelector('[data-photo-prev]');
    var nextBtn = dialog.querySelector('[data-photo-next]');
    var zoomControls = dialog.querySelector('[data-photo-zoom-controls]');
    var zoomInBtn = dialog.querySelector('[data-photo-zoom-in]');
    var zoomOutBtn = dialog.querySelector('[data-photo-zoom-out]');
    var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-zoom-src]'));
    if (!items.length) return;

    var MAX_ZOOM = 4;
    var index = 0;
    var baseW = 0, baseH = 0;      // photo size at "fit to screen"
    var maxScale = 1;              // capped at the photo's real resolution
    var scale = 1, tx = 0, ty = 0; // current zoom and pan
    var pointers = {};
    var gesture = null;
    var lastTap = { time: 0, x: 0, y: 0 };

    function stageRect() { return stage.getBoundingClientRect(); }

    function render() {
      img.style.transform = 'translate(-50%, -50%) translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
      stage.classList.toggle('is-zoomed', scale > 1.01);
      stage.classList.toggle('is-zoomable', maxScale > 1 && scale <= 1.01);
      if (zoomInBtn) zoomInBtn.disabled = scale >= maxScale - 0.01;
      if (zoomOutBtn) zoomOutBtn.disabled = scale <= 1.01;
    }

    // Keep the photo's edges from being dragged inside the screen
    function clampPan() {
      var r = stageRect();
      var limX = Math.max(0, (baseW * scale - r.width) / 2);
      var limY = Math.max(0, (baseH * scale - r.height) / 2);
      tx = Math.min(limX, Math.max(-limX, tx));
      ty = Math.min(limY, Math.max(-limY, ty));
    }

    // Zoom to newScale keeping the point (cx, cy), in screen pixels, under the finger/cursor
    function zoomAt(newScale, cx, cy, animate) {
      newScale = Math.min(maxScale, Math.max(1, newScale));
      var r = stageRect();
      var px = cx - (r.left + r.width / 2);
      var py = cy - (r.top + r.height / 2);
      var ratio = newScale / scale;
      tx = px - (px - tx) * ratio;
      ty = py - (py - ty) * ratio;
      scale = newScale;
      clampPan();
      stage.classList.toggle('is-animating', !!animate);
      render();
    }

    function zoomCenter(newScale) {
      var r = stageRect();
      zoomAt(newScale, r.left + r.width / 2, r.top + r.height / 2, true);
    }

    function toggleZoomAt(cx, cy) {
      if (scale > 1.01) zoomCenter(1);
      else zoomAt(Math.min(maxScale, 2.5), cx, cy, true);
    }

    // Fit the photo to the screen; small photos are not blown up past twice their size
    function layout() {
      var item = items[index];
      var w = parseFloat(item.getAttribute('data-zoom-w')) || 1;
      var h = parseFloat(item.getAttribute('data-zoom-h')) || 1;
      var r = stageRect();
      var fit = Math.min(r.width / w, r.height / h, 2);
      baseW = w * fit;
      baseH = h * fit;
      img.style.width = baseW + 'px';
      img.style.height = baseH + 'px';
      // Zooming further than the photo file's own pixels only shows blur
      maxScale = Math.min(MAX_ZOOM, Math.max(1, w / baseW));
      if (maxScale < 1.15) maxScale = 1;
      if (zoomControls) zoomControls.hidden = maxScale === 1;
      scale = Math.min(scale, maxScale);
      clampPan();
      render();
    }

    function show(i) {
      index = (i + items.length) % items.length;
      var item = items[index];
      var small = item.querySelector('img');
      scale = 1; tx = 0; ty = 0;
      stage.classList.remove('is-animating');
      // Show the already-loaded gallery photo at once, swap in the sharp one when it arrives
      img.src = (small && (small.currentSrc || small.src)) || item.getAttribute('data-zoom-src');
      img.alt = small ? small.alt : '';
      var hiRes = new Image();
      var wanted = index;
      hiRes.onload = function () { if (wanted === index) img.src = hiRes.src; };
      hiRes.src = item.getAttribute('data-zoom-src');
      if (countEl) countEl.textContent = items.length > 1 ? (index + 1) + ' / ' + items.length : '';
      layout();
    }

    function open(i) {
      document.documentElement.classList.add('photo-viewer-open');
      dialog.showModal();
      show(i);
    }

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('photo-viewer-open');
      pointers = {};
      gesture = null;
      // Leave the page gallery on the photo the customer last looked at
      if (productGallery) productGallery.showMedia(items[index].getAttribute('data-media-id'), true);
    });

    gallery.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-photo-open]');
      if (!btn) return;
      var i = items.indexOf(btn.closest('[data-zoom-src]'));
      if (i >= 0) open(i);
    });

    dialog.querySelector('[data-photo-close]').addEventListener('click', function () { dialog.close(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });
    if (zoomInBtn) zoomInBtn.addEventListener('click', function () { zoomCenter(scale * 1.6); });
    if (zoomOutBtn) zoomOutBtn.addEventListener('click', function () { zoomCenter(scale / 1.6); });

    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' && items.length > 1) { show(index - 1); e.preventDefault(); }
      else if (e.key === 'ArrowRight' && items.length > 1) { show(index + 1); e.preventDefault(); }
      else if (e.key === '+' || e.key === '=') { zoomCenter(scale * 1.6); }
      else if (e.key === '-') { zoomCenter(scale / 1.6); }
    });

    window.addEventListener('resize', function () { if (dialog.open) layout(); });

    // Mouse wheel / trackpad pinch zooms around the cursor
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      if (maxScale === 1) return;
      zoomAt(scale * Math.exp(-e.deltaY * 0.002), e.clientX, e.clientY, false);
    }, { passive: false });

    function pointerList() {
      return Object.keys(pointers).map(function (k) { return pointers[k]; });
    }

    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      stage.setPointerCapture(e.pointerId);
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      stage.classList.remove('is-animating');
      var list = pointerList();
      if (list.length === 2) {
        gesture = {
          type: 'pinch',
          dist: Math.hypot(list[0].x - list[1].x, list[0].y - list[1].y),
          scale: scale
        };
      } else if (list.length === 1) {
        gesture = { type: 'drag', startX: e.clientX, startY: e.clientY, lastX: e.clientX, lastY: e.clientY, moved: false, pointerType: e.pointerType };
      }
    });

    stage.addEventListener('pointermove', function (e) {
      if (!pointers[e.pointerId] || !gesture) return;
      pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var list = pointerList();
      if (gesture.type === 'pinch' && list.length === 2) {
        if (maxScale === 1) return;
        var dist = Math.hypot(list[0].x - list[1].x, list[0].y - list[1].y);
        zoomAt(gesture.scale * dist / gesture.dist, (list[0].x + list[1].x) / 2, (list[0].y + list[1].y) / 2, false);
      } else if (gesture.type === 'drag') {
        var dx = e.clientX - gesture.lastX;
        var dy = e.clientY - gesture.lastY;
        gesture.lastX = e.clientX;
        gesture.lastY = e.clientY;
        if (Math.abs(e.clientX - gesture.startX) > 6 || Math.abs(e.clientY - gesture.startY) > 6) gesture.moved = true;
        if (scale > 1.01) {
          tx += dx;
          ty += dy;
          clampPan();
        } else {
          // Not zoomed: the photo follows the finger sideways (swipe to the next photo)
          tx = e.clientX - gesture.startX;
          ty = 0;
        }
        render();
      }
    });

    function endPointer(e) {
      if (!pointers[e.pointerId]) return;
      delete pointers[e.pointerId];
      var remaining = pointerList();
      if (!gesture) return;

      if (gesture.type === 'pinch') {
        // One finger still down after a pinch: keep panning from where it is
        gesture = remaining.length === 1
          ? { type: 'drag', startX: remaining[0].x, startY: remaining[0].y, lastX: remaining[0].x, lastY: remaining[0].y, moved: true }
          : null;
        return;
      }

      if (remaining.length) return;
      var g = gesture;
      gesture = null;
      var dx = e.clientX - g.startX;
      var dy = e.clientY - g.startY;

      if (scale <= 1.01 && g.moved) {
        if (items.length > 1 && Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) {
          show(index + (dx < 0 ? 1 : -1));
        } else if (dy > 120 && Math.abs(dy) > Math.abs(dx)) {
          dialog.close();
        } else {
          tx = 0; ty = 0;
          stage.classList.add('is-animating');
          render();
        }
        return;
      }
      if (g.moved || maxScale === 1) return;

      // Mouse: one click zooms in / out. Touch: double-tap does.
      if (g.pointerType === 'mouse') {
        toggleZoomAt(e.clientX, e.clientY);
      } else {
        var now = Date.now();
        if (now - lastTap.time < 300 && Math.abs(e.clientX - lastTap.x) < 30 && Math.abs(e.clientY - lastTap.y) < 30) {
          toggleZoomAt(e.clientX, e.clientY);
          lastTap.time = 0;
        } else {
          lastTap = { time: now, x: e.clientX, y: e.clientY };
        }
      }
    }

    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);
  }

  // -- Variant Picker: keeps the hidden variant id, price, button and photo in sync --
  function initVariantPicker() {
    var form = document.querySelector('[data-product-form]');
    var dataEl = document.getElementById('ProductVariantsJson');
    if (!form || !dataEl) return;

    var variants = JSON.parse(dataEl.textContent);
    var selects = form.querySelectorAll('[data-option-index]');
    var idInput = form.querySelector('[data-variant-id]');
    var button = form.querySelector('[data-add-button]');
    var priceEl = document.querySelector('[data-product-price]');
    var leadTimeEl = document.querySelector('[data-lead-time]');
    var alwaysLeadTime = leadTimeEl && leadTimeEl.hasAttribute('data-always');
    var inStockEl = document.querySelector('[data-in-stock]');
    var soldOutEl = document.querySelector('[data-sold-out-note]');
    if (!selects.length || !idInput) return;

    // Colour dots: the hidden input holds the picked colour, empty while none is
    // picked; the customer is then asked for one before adding to the cart.
    var colorPicker = form.querySelector('[data-color-picker]');
    var colorInput = colorPicker && colorPicker.querySelector('[data-option-index]');
    var colorAlert = colorPicker && colorPicker.querySelector('[data-color-alert]');
    var alertTimer = null;

    function colorMissing() {
      return !!colorInput && colorInput.value === '';
    }

    // Variants that fit every picked option; a colour not picked yet fits any colour.
    // Options may be displayed in a different order than the product's options
    // (size last), so each one is matched by its data-option-index.
    function matchingVariants() {
      return variants.filter(function (variant) {
        for (var j = 0; j < selects.length; j++) {
          var optionIndex = parseInt(selects[j].getAttribute('data-option-index'), 10);
          if (selects[j].value !== '' && variant.options[optionIndex] !== selects[j].value) return false;
        }
        return true;
      });
    }

    function setUrlVariant(id) {
      var url = new URL(window.location.href);
      if (id) url.searchParams.set('variant', id);
      else url.searchParams.delete('variant');
      window.history.replaceState({}, '', url.toString());
    }

    // source: none on page load, 'option' when the customer picks a colour or size,
    // 'photo' when the colour followed a photo they picked
    function update(source) {
      var noColor = colorMissing();
      var matches = matchingVariants();
      // No colour yet: show the price of a buyable variant in the picked size
      var variant = noColor
        ? matches.filter(function (v) { return v.available; })[0] || matches[0]
        : matches[0];

      // Lead time note: made-to-order products, or a size that is out of stock but still sold
      if (leadTimeEl) {
        leadTimeEl.hidden = !(alwaysLeadTime || (!noColor && variant && variant.made_to_order));
      }

      // In stock note: the picked colour and size is on the shelf and ships within 2 working days
      if (inStockEl) {
        inStockEl.hidden = !(!noColor && variant && variant.in_stock);
      }

      // Sold out note: the picked colour and size can't be ordered at all
      if (soldOutEl) {
        soldOutEl.hidden = !(!noColor && !alwaysLeadTime && variant && !variant.available);
      }

      if (!variant) {
        // Combination doesn't exist — block adding the wrong item
        button.disabled = true;
        button.textContent = button.getAttribute('data-sold-out-text');
        return;
      }

      if (priceEl) {
        priceEl.innerHTML = variant.compare_at_price
          ? '<span class="product-layout__price--original">' + variant.compare_at_price + '</span> ' +
            '<span class="product-layout__price--sale">' + variant.price + '</span>'
          : variant.price;
      }

      if (noColor) {
        // The button stays usable and asks for a colour (submit handler below)
        button.disabled = false;
        button.textContent = button.getAttribute('data-add-text');
        if (source) setUrlVariant(null);
        return;
      }

      idInput.value = variant.id;
      button.disabled = !variant.available;
      button.textContent = button.getAttribute(variant.available ? 'data-add-text' : 'data-sold-out-text');

      if (!source) return;

      // Show the colour's photo, unless the colour came from the photo the customer picked
      if (source === 'option' && variant.media_id && productGallery) {
        productGallery.showMedia(variant.media_id);
      }
      setUrlVariant(variant.id);
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () { update('option'); });
    });

    if (colorPicker) {
      var colorRadios = colorPicker.querySelectorAll('[data-color-radio]');

      // Show a colour as picked (or none, with '') on the dots and after "Värv"
      var setColor = function (value) {
        colorInput.value = value;
        colorRadios.forEach(function (radio) { radio.checked = radio.value === value; });
        colorPicker.querySelector('[data-color-name]').textContent = value;
        colorPicker.querySelector('[data-color-current]').hidden = value === '';
        if (value) hideAlert();
      };

      var hideAlert = function () {
        clearTimeout(alertTimer);
        colorAlert.hidden = true;
        colorPicker.classList.remove('is-missing');
      };

      // "Palun vali värv" under the dots; the dots give a small shake
      var showAlert = function () {
        colorAlert.hidden = false;
        colorPicker.classList.remove('is-missing');
        void colorPicker.offsetWidth; // restart the shake
        colorPicker.classList.add('is-missing');
        var rect = colorPicker.getBoundingClientRect();
        if (rect.top < 80 || rect.bottom > window.innerHeight) {
          colorPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        clearTimeout(alertTimer);
        alertTimer = setTimeout(hideAlert, 4000);
      };

      colorRadios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          setColor(radio.value);
          update('option');
        });
      });

      form.addEventListener('submit', function (e) {
        if (!colorMissing()) return;
        e.preventDefault();
        showAlert();
      });

      // Each photo's colours: the photo set on a variant in Shopify belongs to its colour
      var colorIndex = parseInt(colorInput.getAttribute('data-option-index'), 10);
      var photoColors = {};
      variants.forEach(function (variant) {
        if (!variant.media_id) return;
        var colors = photoColors[variant.media_id] || (photoColors[variant.media_id] = []);
        if (colors.indexOf(variant.options[colorIndex]) === -1) colors.push(variant.options[colorIndex]);
      });

      // Picking a photo picks its colour; a photo that is no colour's photo (or
      // several colours') leaves no colour picked. On products without any colour
      // photos, looking through the photos keeps the customer's pick.
      if (productGallery && Object.keys(photoColors).length) {
        productGallery.onPhotoPicked = function (mediaId) {
          var colors = photoColors[mediaId] || [];
          if (colors.indexOf(colorInput.value) !== -1) return;
          setColor(colors.length === 1 ? colors[0] : '');
          update('photo');
        };
      }
    }

    // Browsers can restore old dropdown and dot choices on back/forward or reload,
    // so start from what the page shows
    function resync() {
      if (colorPicker) {
        var checked = colorPicker.querySelector('[data-color-radio]:checked');
        setColor(checked ? checked.value : '');
      }
      update();
    }
    resync();
    window.addEventListener('pageshow', resync);
  }

  // -- Product card colour dots --
  // Clicking or tapping a colour that has its own photo shows it on the card and makes
  // the card open that colour; clicking it again, or a colour without a photo, opens
  // the product.
  function initCardSwatches() {
    document.querySelectorAll('.card-swatches').forEach(function (list) {
      var card = list.closest('.product-card');
      var img = card && card.querySelector('img.product-card__image--primary');
      if (!img) return;
      var cardLinks = card.querySelectorAll('.product-card__link, .product-card__price');
      var selected = null;

      function select(link) {
        if (selected) selected.classList.remove('is-selected');
        selected = link;
        link.classList.add('is-selected');
        cardLinks.forEach(function (a) { a.setAttribute('href', link.getAttribute('href')); });
        var src = link.getAttribute('data-swatch-image');
        img.setAttribute('src', src);
        img.setAttribute('srcset', link.getAttribute('data-swatch-srcset') || src);
      }

      list.querySelectorAll('.card-swatches__link').forEach(function (link) {
        link.addEventListener('click', function (e) {
          if (!link.hasAttribute('data-swatch-image') || link === selected) return;
          e.preventDefault();
          select(link);
        });
      });
    });
  }

  // -- "Lisatud ostukorvi" panel --
  // "Lisa ostukorvi" adds the item without leaving the product page and opens a
  // panel with the item, the cart total, "Vormista tellimus" (cart page) and
  // "Jätka ostlemist". Without fetch/<dialog> the form posts to the cart as before.
  function initCartAdded() {
    var form = document.querySelector('[data-product-form]');
    var dialog = document.querySelector('[data-cart-added]');
    if (!form || !dialog || !window.fetch || typeof dialog.showModal !== 'function') return;

    var button = form.querySelector('[data-add-button]');
    var errorEl = form.querySelector('[data-add-error]');
    var badge = document.getElementById('cart-count');
    var busy = false;
    var defaultError = errorEl && errorEl.textContent;

    // Same format as the theme's prices: 1.260,00 €
    function money(cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1] + '\u00a0€';
    }

    function close() {
      dialog.classList.add('is-closing');
      setTimeout(function () {
        dialog.classList.remove('is-closing');
        dialog.close();
      }, 200);
    }

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('cart-added-open');
    });
    dialog.querySelectorAll('[data-cart-added-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    // A tap on the dimmed page around the panel closes it
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      close();
    });

    function fill(item, cart) {
      var image = dialog.querySelector('[data-cart-added-image]');
      if (item.image) {
        image.src = item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=144';
        image.alt = item.product_title;
        image.hidden = false;
      } else {
        image.hidden = true;
      }
      dialog.querySelector('[data-cart-added-name]').textContent = item.product_title;
      var values = (item.options_with_values || [])
        .map(function (o) { return o.value; })
        .filter(function (v) { return v && v !== 'Default Title'; });
      var variantEl = dialog.querySelector('[data-cart-added-variant]');
      variantEl.textContent = values.join(' · ');
      variantEl.hidden = values.length === 0;
      dialog.querySelector('[data-cart-added-price]').textContent = money(item.final_price);
      dialog.querySelector('[data-cart-added-count]').textContent = '(' + cart.item_count + ' ' +
        dialog.getAttribute(cart.item_count === 1 ? 'data-item-one' : 'data-item-other') + ')';
      dialog.querySelector('[data-cart-added-total]').textContent = money(cart.total_price);
      if (badge) badge.textContent = cart.item_count;
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || defaultError;
      errorEl.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      // The colour check (initVariantPicker) may already have stopped it
      if (e.defaultPrevented) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      button.classList.add('is-loading');
      if (errorEl) errorEl.hidden = true;

      var headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      fetch(dialog.getAttribute('data-add-url'), { method: 'POST', body: new FormData(form), headers: headers })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw { shopifyMessage: data.description || data.message };
            return data;
          });
        })
        .then(function (item) {
          return fetch(dialog.getAttribute('data-cart-url'), { headers: headers })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              fill(item, cart);
              document.documentElement.classList.add('cart-added-open');
              dialog.showModal();
            });
        })
        .catch(function (err) {
          // Shopify's own message (e.g. no more in stock); otherwise the general one
          showError(err && err.shopifyMessage);
        })
        .then(function () {
          busy = false;
          button.classList.remove('is-loading');
        });
    });
  }

  // -- Initialize Everything --
  // -- Header search: magnifier opens a search bar, results drop down as you type --
  function initHeaderSearch() {
    var toggle = document.getElementById('search-toggle');
    var panel = document.getElementById('header-search');
    if (!toggle || !panel || !window.fetch) return;
    var input = document.getElementById('header-search-input');
    var results = document.getElementById('header-search-results');
    var closeBtn = document.getElementById('header-search-close');
    var form = panel.querySelector('form');
    var suggestUrl = panel.getAttribute('data-suggest-url') || '/search/suggest';
    var timer = null;
    var controller = null;
    var lastTerms = '';
    var cache = {};

    function open() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      // Focus straight away (inside the click) so phones open the keyboard
      input.focus();
      if (input.value) input.select();
    }

    function close() {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    function links() {
      return Array.prototype.slice.call(results.querySelectorAll('a'));
    }

    function show(html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var drop = tmp.querySelector('.search-drop');
      results.innerHTML = drop ? drop.outerHTML : '';
    }

    function search(terms) {
      if (cache[terms] !== undefined) { show(cache[terms]); return; }
      if (controller) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      var url = suggestUrl + '?q=' + encodeURIComponent(terms) +
        '&section_id=predictive-search' +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,tag';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          cache[terms] = html;
          if (input.value.trim() === terms) show(html);
        })
        .catch(function () {});
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (panel.hidden) open(); else close();
    });

    closeBtn.addEventListener('click', function () { close(); toggle.focus(); });

    input.addEventListener('input', function () {
      var terms = input.value.trim();
      clearTimeout(timer);
      if (!terms) {
        lastTerms = '';
        if (controller) controller.abort();
        results.innerHTML = '';
        return;
      }
      if (terms === lastTerms) return;
      lastTerms = terms;
      timer = setTimeout(function () { search(terms); }, 180);
    });

    // Arrow keys move through the results, Enter opens the highlighted one, Escape closes
    input.addEventListener('keydown', function (e) {
      var items = links();
      var current = results.querySelector('a.is-active');
      var index = items.indexOf(current);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!items.length) return;
        e.preventDefault();
        if (current) current.classList.remove('is-active');
        index = e.key === 'ArrowDown' ? index + 1 : index - 1;
        if (index >= items.length) index = 0;
        if (index < 0) index = items.length - 1;
        items[index].classList.add('is-active');
        items[index].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && current) {
        e.preventDefault();
        window.location.href = current.href;
      } else if (e.key === 'Escape') {
        close();
        toggle.focus();
      }
    });

    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) e.preventDefault();
    });

    // Clicking anywhere outside the header closes the search bar
    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (panel.contains(e.target) || toggle.contains(e.target)) return;
      close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close();
    });
  }

  // -- Cookie banner --
  // Footer "Cookie settings" links reopen Shopify's cookie settings window, so a
  // choice is as easy to change as it was to make. Without the banner script the
  // link just opens the privacy policy. The banner's texts come from the locale
  // files (#CookieBannerText in the footer): Shopify can't translate them into
  // English through its API. Its own policy link pointed at the old /et-ee/ address.
  function initCookieBanner() {
    var links = document.querySelectorAll('[data-cookie-settings]');
    if (!links.length) return;
    var policyUrl = links[0].href;
    var text = {};
    try {
      text = JSON.parse(document.getElementById('CookieBannerText').textContent);
    } catch (e) {}

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
        e.preventDefault();
        window.privacyBanner.showPreferences();
      });
    });

    // The t filter HTML-escapes apostrophes (Google&#39;is), so decode before use
    function decode(value) {
      return new DOMParser().parseFromString(value, 'text/html').documentElement.textContent;
    }

    function setText(el, value) {
      if (el && value) el.textContent = decode(value);
    }

    // Option labels hold the name as their first text node, followed by the checkbox
    function setOption(id, name, desc) {
      var option = document.getElementById(id);
      if (!option) return;
      var label = option.querySelector('label');
      if (label && label.firstChild && label.firstChild.nodeType === 3 && name) label.firstChild.nodeValue = decode(name);
      setText(option.querySelector('p'), desc);
    }

    function applyBanner() {
      var banner = document.getElementById('shopify-pc__banner');
      if (!banner || banner.dataset.meknit) return;
      banner.dataset.meknit = 'true';
      var policyLink = document.getElementById('shopify-pc__banner__body-policy-link');
      var body = policyLink && policyLink.parentNode;
      if (body && text.text) {
        body.textContent = decode(text.text) + ' ';
        body.appendChild(policyLink);
      }
      if (policyLink) policyLink.href = policyUrl;
      setText(policyLink, text.policy_link);
      setText(document.getElementById('shopify-pc__banner__body-title'), text.title);
      setText(document.getElementById('shopify-pc__banner__btn-accept'), text.accept);
      setText(document.getElementById('shopify-pc__banner__btn-decline'), text.decline);
      setText(banner.querySelector('#shopify-pc__banner__btn-manage-prefs span'), text.manage);
    }

    function applyPrefs() {
      var dialog = document.getElementById('shopify-pc__prefs__dialog');
      if (!dialog || dialog.dataset.meknit) return;
      dialog.dataset.meknit = 'true';
      setText(document.getElementById('shopify-pc__prefs__header-title'), text.prefs_title);
      setText(document.getElementById('shopify-pc__prefs__header-accept'), text.prefs_accept);
      setText(document.getElementById('shopify-pc__prefs__header-decline'), text.prefs_decline);
      setText(document.getElementById('shopify-pc__prefs__header-save'), text.prefs_save);
      setText(dialog.querySelector('.shopify-pc__prefs__intro h3'), text.intro_title);
      setText(dialog.querySelector('.shopify-pc__prefs__intro p'), text.intro_text);
      setOption('shopify-pc__prefs__essential', text.essential_name, text.essential_desc);
      setOption('shopify-pc__prefs__analytics', text.analytics_name, text.analytics_desc);
      setOption('shopify-pc__prefs__preferences', text.preferences_name, text.preferences_desc);
      setOption('shopify-pc__prefs__marketing', text.marketing_name, text.marketing_desc);
    }

    // Shopify adds (and may rebuild) the banner and the settings window after page load
    function apply() {
      applyBanner();
      applyPrefs();
    }
    apply();
    new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    initHeaderShadow();
    initMenu();
    initFooterGroups();
    initCarousel();
    initProductGallery();
    initPhotoViewer();
    initVariantPicker();
    initCartAdded();
    initCardSwatches();
    initHeaderSearch();
    initCookieBanner();
  });
})();
